import "core-js/modules/es.array.fill.js";
export var progressBarPortalTokens = {
  radius: 8,
  sizes: {
    s: {
      height: 2
    },
    m: {
      height: 8
    },
    l: {
      height: 16
    }
  },
  defaultSize: "m",
  bgColor: function bgColor(_ref) {
    var color = _ref.color;
    return color.fill.page.back;
  },
  progressColor: function progressColor(_ref2) {
    var color = _ref2.color;
    return color.importance.primary.base;
  }
};